import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {api, isDuplicateRequest} from "utils";

const initialState = {
	searchPartner : 0,
	searchBranch : 0,
	searchBranchUseYn : "",
	searchDate : "",
	searchScheduleType : "",
	searchCoach : 0,
	searchCancelYn : "N",
	searchRelativeDate : "",
	pageScroll : 0,

	scheduleInfo : {
		data : undefined,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	scheduleList : {
		data : undefined,
		page : 1,
		pageSize : 10,
		pageState : true,
		lastSeqSchedule : 0,
		lastSeqPartnerClassSchedule : 0,
		timestamp : undefined
	},
};

const schedule = createSlice({
	name : "schedule",
	initialState,
	reducers : {
		fetchSearchInfo : (state, action) => {
			state = Object.assign(state, action.payload);
		},
		fetchScheduleInfo : (state, action) => {
			state.scheduleInfo = Object.assign(state.scheduleInfo, action.payload);
		},
		fetchScheduleList : (state, action) => {
			state.scheduleList = Object.assign(state.scheduleList, action.payload);
		},
		fetchScheduleListList : (state, action) => {
			const {scheduleList, isCancelYn, lastSeqSchedule, lastSeqPartnerClassSchedule} = action.payload;
			if(isCancelYn) {
				state.scheduleList.data.scheduleList = [];
				state.scheduleList.page = 1;
			}
			state.scheduleList.data.scheduleList = state.scheduleList.data.scheduleList.concat(scheduleList);
			state.scheduleList.page = state.scheduleList.page + 1;
			state.scheduleList.pageState = (scheduleList.length == state.scheduleList.pageSize);
			if(state.scheduleList.page == 2) {
				state.scheduleList.lastSeqSchedule = lastSeqSchedule;
				state.scheduleList.lastSeqPartnerClassSchedule = lastSeqPartnerClassSchedule;
			}
		},
		fetchScheduleListSummaryInfo : (state, action) => {
			if(!state.scheduleList.data) {
				console.log("[WARNING]");
				state.scheduleList.data = {
					summaryInfo : {},
					scheduleList : []
				};
			}
			const {summaryInfo, isCancelYn} = action.payload;
			state.scheduleList.data.summaryInfo = (isCancelYn) ?
				summaryInfo : Object.assign(state.scheduleList.data.summaryInfo, summaryInfo)
		},
		fetchReset : (state, action) => {
			state = Object.assign(state, initialState, action.payload);
		},
		fetchPageScroll : (state, action) => {
			const container = document.querySelector("#content");
			if(action.payload == "restore") {
				container.scrollTop = state.pageScroll;
			} else {
				state.pageScroll = container.scrollTop;
			}
		}
	},

	/*
	extraReducers: (builder) => {
		builder
			.addCase(updateScheduleInfo.pending, (state, action) => {
				state.scheduleInfo.requestId = action.meta.requestId;
				state.scheduleInfo.data = {};
				state.scheduleInfo.isLoading = true;
				state.scheduleInfo.isError = false;
			})
			.addCase(updateScheduleInfo.fulfilled, (state, action) => {
				if(state.scheduleInfo.requestId == action.meta.requestId) {
					state.scheduleInfo.data = action.payload || {};
					state.scheduleInfo.requestId = undefined;
					state.scheduleInfo.isLoading = false;
				}
			})
			.addCase(updateScheduleInfo.rejected, (state, action) => {
				if(state.scheduleInfo.requestId == action.meta.requestId) {
					state.scheduleInfo.isError = true;
					state.scheduleInfo.isLoading = false;
					state.scheduleInfo.requestId = undefined;
				}
			});
	}
	*/
});

export const {
	fetchSearchInfo,
	fetchScheduleInfo,
	fetchScheduleList,
	fetchScheduleListList,
	fetchScheduleListSummaryInfo,
	fetchPageScroll,
	fetchReset
} = schedule.actions;

export const updateScheduleList = (isUpdate, isCancelYn) => (dispatch, getState) => {
	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchCoach,
		searchScheduleType,
		searchCancelYn,
		scheduleList
	} = getState().schedule;

	if(!searchPartner || !searchDate) return;

	if(isUpdate) {
		// const timestamp = (isCancelYn) ? Date.now() - 500 : Date.now();
		const timestamp = Date.now();
		// 2022.07.22 CRM-2980 문제로 주석처리
		// if(isDuplicateRequest(scheduleList.timestamp)) {
		// 	console.log("duplicated");
		// 	return;
		// }
		dispatch(fetchScheduleList({
			pageState : undefined,
			timestamp : timestamp
		}));
		api.post("/schedules", {
			seqPartner : searchPartner,
			seqPartnerBranch : searchBranch,
			seqPartnerCoach : searchCoach,
			scheduleFilter : searchScheduleType || "ALL",
			criteria : {
				"page" : (isCancelYn) ? 1 : scheduleList.page,
				"pageSize" : scheduleList.pageSize
			},
			searchDate : searchDate,
//			searchCancelYn : searchCancelYn,
			lastSeqSchedule : (isCancelYn) ? 0 : scheduleList.lastSeqSchedule,
			lastSeqPartnerClassSchedule : (isCancelYn) ? 0 : scheduleList.lastSeqPartnerClassSchedule
		}).then(({data}) => {
			const {scheduleList} = getState().schedule;
			if(timestamp == scheduleList.timestamp) {
				const dataInfo = (data || {}).page || {};
				const summaryInfo = data.dailyScheduleCounts || {};
				const scheduleList = dataInfo.results || [];
				dispatch(fetchScheduleListSummaryInfo({
					summaryInfo : summaryInfo,
					isCancelYn : isCancelYn
				}));
				dispatch(fetchScheduleListList({
					scheduleList : scheduleList || [],
					lastSeqSchedule : data.lastSeqSchedule || 0,
					lastSeqPartnerClassSchedule : data.lastSeqPartnerClassSchedule || 0,
					isCancelYn : isCancelYn
				}));
			}
		}).catch(error => {
			const {scheduleList} = getState().schedule;
			if(timestamp == scheduleList.timestamp) {
				console.log(error);
				dispatch(fetchScheduleList({
					pageState : false
				}));
			}
		});
	} else {
		dispatch(fetchScheduleList({
			data : {
				searchInfo : {
					searchPartner : searchPartner,
					searchBranch : searchBranch,
					searchDate : searchDate,
					searchCoach : searchCoach,
					searchScheduleType : searchScheduleType,
					searchCancelYn : searchCancelYn
				},
				summaryInfo : {},
				scheduleList : []
			},
			page : 1,
			pageState : true,
			lastSeqSchedule : 0,
			lastSeqPartnerClassSchedule : 0,
			timestamp : undefined
		}));
	}
};

export const updateScheduleInfo = ({serviceType, sequence}) => (dispatch, getState) => {
	const {scheduleInfo} = getState().schedule;
	const timestamp = Date.now();
	if(isDuplicateRequest(scheduleInfo.timestamp)) return;

	dispatch(fetchScheduleInfo({
		data : {},
		isLoading : true,
		isError : false,
		timestamp : timestamp
	}));

	api.get("/schedules/" + serviceType + "/" + sequence).then(({data}) => {
		const {scheduleInfo} = getState().schedule;
		if(timestamp == scheduleInfo.timestamp) {
			dispatch(fetchScheduleInfo({
				data : data,
				isLoading : false,
				isError : false
			}));
		}
	}).catch(error => {
		const {scheduleInfo} = getState().schedule;
		if(timestamp == scheduleInfo.timestamp) {
			dispatch(fetchScheduleInfo({
				isLoading : false,
				isError : true
			}));
		}
	});
};

/*
export const updateScheduleInfo = createAsyncThunk(
	"schedule/updateScheduleInfo",
	async (object, thunkAPI) => {
		const {serviceType, sequence} = object;
		const response = await api.get("/schedules/" + serviceType + "/" + sequence);
		return response.data;
	}
);
*/

export default schedule.reducer;
